import React from 'react';

import { useIntl } from 'react-intl';

export const TextWithLangLinks = ({
  textId,
  enLinkRouteId,
  frLinkRouteId,
  ...rest
}: ITextWithLangLinks) => {
  const { formatMessage } = useIntl();

  return (
    <span data-testid="text-with-lang-links" {...rest}>
      {formatMessage(
        { id: textId },
        {
          enLink: <a href={formatMessage({ id: enLinkRouteId })}>{formatMessage({ id: 'en' })}</a>,
          frLink: <a href={formatMessage({ id: frLinkRouteId })}>{formatMessage({ id: 'fr' })}</a>,
        }
      )}
    </span>
  );
};
